const REGION_CODE_PATTERN = /^[A-Z]{2}$/

const getRegionNames = locale => {
	try {
		return new Intl.DisplayNames([locale || 'en'], { type: 'region' })
	} catch (error) {
		return null
	}
}

export const normalizeCountryCode = countryCode => String(countryCode || '').trim().toUpperCase()

export const getCountryFlag = countryCode => {
	const normalizedCountryCode = normalizeCountryCode(countryCode)

	if (!REGION_CODE_PATTERN.test(normalizedCountryCode)) {
		return ''
	}

	return [...normalizedCountryCode]
		.map(character => String.fromCodePoint(127397 + character.charCodeAt(0)))
		.join('')
}

export const getCountryName = (countryCode, locale = 'en') => {
	const normalizedCountryCode = normalizeCountryCode(countryCode)

	if (!REGION_CODE_PATTERN.test(normalizedCountryCode)) {
		return normalizedCountryCode
	}

	const regionNames = getRegionNames(locale)
	return regionNames?.of(normalizedCountryCode) || normalizedCountryCode
}

export const formatCountryOptionLabel = (countryCode, locale = 'en') => {
	const normalizedCountryCode = normalizeCountryCode(countryCode)
	const flag = getCountryFlag(normalizedCountryCode)
	const name = getCountryName(normalizedCountryCode, locale)

	return flag ? `${flag} ${name} (${normalizedCountryCode})` : `${name} (${normalizedCountryCode})`
}

const LAST_PICKED_COUNTRY_KEY = 'lastPickedCountryCode'

export const getLastPickedCountryCode = () => localStorage.getItem(LAST_PICKED_COUNTRY_KEY) || ''

export const setLastPickedCountryCode = countryCode =>
	localStorage.setItem(LAST_PICKED_COUNTRY_KEY, normalizeCountryCode(countryCode))

export const getDefaultPickedCountry = availableCountries => {
	const lastPicked = getLastPickedCountryCode()
	return availableCountries.includes(lastPicked) ? lastPicked : availableCountries[0] || ''
}
